import { useState, useEffect } from 'react'

const COMPACT_MAX_WIDTH = 767

const getIsCompact = () => typeof window !== 'undefined'
  && window.matchMedia(`(max-width: ${COMPACT_MAX_WIDTH}px)`).matches

export const useIsCompactLayout = (): boolean => {
  const [isCompact, setIsCompact] = useState(getIsCompact)

  useEffect(() => {
    if (typeof window === 'undefined') return undefined
    const mq = window.matchMedia(`(max-width: ${COMPACT_MAX_WIDTH}px)`)
    const handler = (e: MediaQueryListEvent) => setIsCompact(e.matches)
    mq.addEventListener('change', handler)
    return () => mq.removeEventListener('change', handler)
  }, [])

  return isCompact
}
